import React, {useState} from "react";
import {Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, Typography} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {iEnrollment} from "../../types/iEnrollment";
import {isValid, parseISO} from "date-fns";
import format from "date-fns/format";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {useDispatch} from "react-redux";
import {patchEnrollmentDate, patchEnrollmentExpireDate} from "../../store/actions/alunosActions";
import ImpressaoFichaDisciplinasCall from "./ImpressaoFichaDisciplinasCall";
import ImpressaoFichaMatriculaCall from "./ImpressaoFichaMatriculaCall";
import ImpressaoGradeNotasGeralAlunoCall from "./ImpressaoGradeNotasGeralAlunoCall";
import { sharedStyles } from "./alunoDialogStyles";

const sxStyles = {
    mainGrid: {
        ...sharedStyles.containerRow,
        marginBottom: '15px',
    },
    discGrid: sharedStyles.containerRowNoWrap,
}

interface iAlunoEnrollment  {
    registro: iEnrollment,
    eilId: number,
    eId: number,
    aluno: any,
    ixeId: number
}


const AlunoEnrollment = ({ registro, eilId, eId, aluno, ixeId  } : iAlunoEnrollment ) => {
    const dispatch = useDispatch();
    const [editExpireOpen, setEditExpireOpen] = useState(false);
    const [editDateOpen, setEditDateOpen] = useState(false);
    const [newExpireDate, setNewExpireDate] = useState<Date | null>(null);
    const [newDate, setNewDate] = useState<Date | null>(null);

    const handleEditExpireOpen = () => {
        const parsed = parseISO(registro.dhExpireDate);
        setNewExpireDate(isValid(parsed) ? parsed : new Date());
        setEditExpireOpen(true);
    };

    const handleEditExpireSave = () => {
        if (newExpireDate && registro.id && aluno?.id) {
            // @ts-ignore
            dispatch(patchEnrollmentExpireDate(aluno.id, registro.id, newExpireDate));
        }
        setEditExpireOpen(false);
    };

    const handleEditDateOpen = () => {
        const parsed = parseISO(registro.dhDate);
        setNewDate(isValid(parsed) ? parsed : new Date());
        setEditDateOpen(true);
    };

    const handleEditDateSave = () => {
        if (newDate && registro.id && aluno?.id) {
            // @ts-ignore
            dispatch(patchEnrollmentDate(aluno.id, registro.id, newDate));
        }
        setEditDateOpen(false);
    };

    return (<React.Fragment>
                <Paper variant="outlined" sx={{ p: 1, '&:hover': { boxShadow: 1 } }}>
                    <Grid container sx={{...sxStyles.mainGrid}}>
                        <Grid item container sx={{...sxStyles.discGrid, justifyContent: 'space-between'}} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant="subtitle2">Matricula #{registro.id}</Typography>
                        </Grid>
                        <Grid item container sx={{...sxStyles.discGrid, justifyContent: 'space-between'}} sm={12} md={12} lg={12} xl={12}>
                            <Typography sx={{display: 'flex', alignItems: 'center'}}>
                                <span>
                                    <Typography variant="caption" color="text.secondary" display="block">Data</Typography>
                                    <Typography variant="body2">{isValid(parseISO(registro.dhDate))? format(parseISO(registro.dhDate), "dd/MM/yyyy"): "I" }</Typography>
                                </span>
                                <IconButton size="small" onClick={handleEditDateOpen} sx={{ml: 0.5}}>
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                            </Typography>
                            <Typography sx={{display: 'flex', alignItems: 'center'}}>
                                <span>
                                    <Typography variant="caption" color="text.secondary" display="block">Expira</Typography>
                                    <Typography variant="body2">{isValid(parseISO(registro.dhExpireDate))? format(parseISO(registro.dhExpireDate), "dd/MM/yyyy"): "F" }</Typography>
                                </span>
                                <IconButton size="small" onClick={handleEditExpireOpen} sx={{ml: 0.5}}>
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                            </Typography>
                        </Grid>
                        <Grid item container sx={{...sxStyles.discGrid, gap: 0.5, mt: 1}} sm={12} md={12} lg={12} xl={12}>
                            <ButtonGroup size="small" variant="text">
                                <ImpressaoFichaMatriculaCall  ixeId={ixeId} eilId={eilId} eId={eId} aluno={aluno}/>
                                <ImpressaoFichaDisciplinasCall ixeId={ixeId} eilId={eilId} eId={eId} aluno={aluno}/>
                                <ImpressaoGradeNotasGeralAlunoCall ixeId={ixeId} eilId={eilId} eId={eId} aluno={aluno}/>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                </Paper>

                {/* Dialog: Alterar Data de Matricula */}
                <Dialog open={editDateOpen} onClose={() => setEditDateOpen(false)}>
                    <DialogTitle>Alterar Data de Matricula</DialogTitle>
                    <DialogContent>
                        <DatePicker
                            label="Nova Data de Matricula"
                            value={newDate}
                            onChange={(date) => setNewDate(date)}
                            sx={{mt: 2}}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setEditDateOpen(false)}>Cancelar</Button>
                        <Button onClick={handleEditDateSave} variant="contained">Salvar</Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog: Alterar Data de Expiracao */}
                <Dialog open={editExpireOpen} onClose={() => setEditExpireOpen(false)}>
                    <DialogTitle>Alterar Data de Expiracao</DialogTitle>
                    <DialogContent>
                        <DatePicker
                            label="Nova Data de Expiracao"
                            value={newExpireDate}
                            onChange={(date) => setNewExpireDate(date)}
                            sx={{mt: 2}}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setEditExpireOpen(false)}>Cancelar</Button>
                        <Button onClick={handleEditExpireSave} variant="contained">Salvar</Button>
                    </DialogActions>
                </Dialog>
    </React.Fragment>);
}
export default (AlunoEnrollment);
